import { FC } from 'react';
import { app, settings } from '../../../@xmcloud/core/messages/en';
import { Stack } from '@chakra-ui/react';
import { useGetOrganizationClientList } from '../../services/clients';
import { CircularLoading, HeadingSm, XMCSH3 } from '../../shared-components';
import { FeatureTogglesPage } from './FeatureTogglesPage';

const { featureToggles } = settings;
const { settings: settingstxt } = app;

export const SettingsPage: FC = () => {
	const { isFetching, isSuccess } = useGetOrganizationClientList();

	if (isFetching || !isSuccess) return <CircularLoading />;

	return (
		<Stack gap={4}>
			<XMCSH3 title={settingstxt} />
			<HeadingSm text={featureToggles} />
			<FeatureTogglesPage />
		</Stack>
	);
};
